import { render, staticRenderFns } from "./MyCourseDetails.vue?vue&type=template&id=659d45eb&scoped=true&"
import script from "./MyCourseDetails.vue?vue&type=script&lang=js&"
export * from "./MyCourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseDetails.vue?vue&type=style&index=0&id=659d45eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d45eb",
  null
  
)

export default component.exports